import * as React from 'react';
import { useSelector } from 'react-redux';
import { SeoMortgageLink as SeoMortgageLinkComponent } from '../../components/SeoMortgageLink';
import { psevdoExperiment2023Q3Selector } from '../../selectors/experiments/controlExperiments';
import { promosSeoPageUrlSelector, promosSeoPageActiveSelector } from '../../selectors/seoPages';
import { trackClickPromosSeoLink } from './tracking';

export const SeoPromosLink = () => {
  const isInControlGroup = useSelector(psevdoExperiment2023Q3Selector);
  const url = useSelector(promosSeoPageUrlSelector);
  const isPageActive = useSelector(promosSeoPageActiveSelector);

  if (!isInControlGroup || !isPageActive) {
    return null;
  }

  return (
    <SeoMortgageLinkComponent
      url={url}
      onClick={trackClickPromosSeoLink}
      title="Акции и скидки"
      testId="seo_promos_link"
    />
  );
};
